"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XSSTooltip = exports.getSafeUrl = exports.isUnsafeUrl = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

/* eslint-disable no-script-url */
var NOOP_HREF = 'javascript:void(0)'; // Match the protocol part of an absolute URL, e.g. "http:"

var PROTOCOL_REGEX = /^([^:]+):/; // Whitespace and control characters are ignored, so we must strip them out
// eslint-disable-next-line no-control-regex

var IGNORED_PROTOCOL_CHARS_REGEX = /[\s\x00-\x1f]/g;

var isUnsafeUrl = function isUnsafeUrl(href) {
  if (href && typeof href === 'string') {
    var protocolMatch = href.match(PROTOCOL_REGEX);
    if (!protocolMatch || href === NOOP_HREF) return false;

    if (protocolMatch[0].replace(IGNORED_PROTOCOL_CHARS_REGEX, '').toLowerCase() === 'javascript:') {
      return true;
    }
  }

  return false;
};

exports.isUnsafeUrl = isUnsafeUrl;

var getSafeUrl = function getSafeUrl(href) {
  if (href && (0, _typeof2.default)(href) === 'object' && typeof href.safeHref === 'string') {
    return href.safeHref;
  }

  return isUnsafeUrl(href) ? NOOP_HREF : href;
};

exports.getSafeUrl = getSafeUrl;
var XSSTooltip = (0, _Controllable.default)(_react.default.createClass({
  displayName: "XSSTooltip",
  propTypes: {
    children: _react.PropTypes.node,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool
  },
  getInitialState: function getInitialState() {
    return {
      open: false
    };
  },
  handleClick: function handleClick(evt) {
    var _this$props = this.props,
        children = _this$props.children,
        onOpenChange = _this$props.onOpenChange,
        open = _this$props.open; // Trigger the child's original onClick, if it has one.

    var child = _react.Children.only(children);

    var originalOnClick = child.props.onClick;
    (0, _Functions.callIfPossible)(originalOnClick, evt); // Toggle the tooltip, unless the app prevents default click behavior.

    if (!evt.defaultPrevented) {
      onOpenChange((0, _SyntheticEvent.default)(!open));
    }
  },
  render: function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        open = _this$props2.open;
    return _react.default.createElement(_UITooltip.default, {
      open: open,
      title: _I18n.default.text('salesUI.XSSTooltip.explanation'),
      use: "danger"
    }, _react.default.cloneElement(children, {
      href: NOOP_HREF,
      onClick: this.handleClick
    }));
  }
}), ['open']);
exports.XSSTooltip = XSSTooltip;